/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { userProfileFeatureKey, userProfileReducer } from './user-profile.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(userProfileFeatureKey, userProfileReducer),
    ],
})
export class UserProfileModule {}
